import React,{ useEffect,useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Rating from '@mui/material/Rating';
import axios from 'axios';

import './index.css';
import { useLocation, useParams } from 'react-router-dom';
import righticon from '../../assests/checkmark.png';

function ThankReviews({ baseURL }) {
  const { templateid, contactid } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  //   console.log('template id in thank', templateid);
  // console.log('contactid id in thank', contactid);

  useEffect(() => {
    ThankAPi();
  },[]);

  const ThankAPi = async () => {
    try {
      const response = await axios.get(`${baseURL}/testing/get-thank/${templateid}/${contactid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      });
      console.log(response,'ThankAPi response');
      setData(response?.data?.data);
    } catch (error) {
      console.log(error,'ThankAPi error');
    }
  };
  return (
    <div className="qs-fade-in flex min-h-[300px] flex-col items-center justify-center space-y-4 py-8 text-center">        
      <div className="qs-success-icon mb-2">
        <img src={righticon} alt="tick mark" className="h-10 w-10 object-contain" />
      </div>
      <div className="qs-title">
        {data?.feedback_thank_you_page_heading || 'Thanks!'} 
      </div>
      <div className="qs-subtitle max-w-[440px]">
        {data?.feedback_thank_you_page_body || 'Thanks for letting us know, we value your feedback.'}                
      </div>
    </div>
  );
}

export default ThankReviews;
